// @ts-nocheck
const asString = (value: unknown): string | undefined => (typeof value === "string" ? value : undefined);

export default asString;
